import React from 'react';
import { motion } from 'framer-motion';
import { HeartIcon } from './icons';
import { useLanguage } from '../context/LanguageContext';
export function EmotionalAmplification() {
  const {
    t
  } = useLanguage();
  return <section className="py-24 bg-brand-bg-dark" data-id="element-84">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-86">
          <div className="flex items-center justify-center gap-4 mb-12" data-id="element-87">
            <HeartIcon className="w-10 h-10 text-brand-gold" data-id="element-88" />
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-white text-center" data-id="element-89">
              {t('emotional.title')}
            </h2>
          </div>

          <div className="space-y-8 text-lg sm:text-xl text-gray-300" data-id="element-90">
            <p className="leading-relaxed" data-id="element-91">{t('emotional.p1')}</p>

            <p className="text-2xl font-heading font-medium text-brand-gold" data-id="element-92">
              {t('emotional.highlight')}
            </p>

            <p className="leading-relaxed" data-id="element-93">
              {t('emotional.p2')}
              <strong className="text-white" data-id="element-94">{t('emotional.p2_strong')}</strong>
            </p>

            <p className="leading-relaxed bg-brand-bg-light p-6 rounded border border-brand-gold/20" data-id="element-95">
              {t('emotional.p3')}
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}